import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";
import "bootstrap/dist/css/bootstrap.min.css";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
/* import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select
} from "@mui/material"; */
const AssignSubjects = () => {
  const [courses, setCourses] = useState([]);
   /* const [academicYears, setAcademicYears] = useState([]); */
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  /* const [selectedAcademicYear, setSelectedAcademicYear] = useState(""); */
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSubjectIDs, setSelectedSubjectIDs] = useState([]);
  const [assignedSubjects, setAssignedSubjects] = useState([]);
  const [staffs, setStaffs] = useState([]);
const [selectedStaff, setSelectedStaff] = useState("");
const [sections,setSections]=useState([]);
const [selectedSection,setSelectedSection]=useState("");
const [showSection, setShowSection] = useState(false);

const [classTeacher, setClassTeacher] = useState(null);
const [loading, setLoading] = useState(false);

const [makeClassTeacher, setMakeClassTeacher] = useState(false);




    /* ========================================================
       INITIAL DATA
    ======================================================== */
  useEffect(() => {
    fetchInitialData();
  }, []);
   const fetchInitialData = async () => {
    try {
      const [courseRes, subjectRes, staffRes] = await Promise.all([
        axios.get(`${BASE_URL}/api/subjectClassCourse/getcourse`),
        axios.get(`${BASE_URL}/api/subjects`),
         axios.get(`${BASE_URL}/api/subjectClassCourse/getstaff`)
      ]);
      setCourses(courseRes.data);
      setSubjects(subjectRes.data);
      setStaffs(staffRes.data);
    } catch (err) {
      console.error("Error fetching initial data", err);
    }
  };
useEffect(() => {
    if (
        selectedCourse &&
        selectedClass
    ) {

        fetchClassTeacher();

    }

}, [
    selectedCourse,
    selectedClass,
    selectedSection,
    showSection
]);
const fetchClassTeacher = async () => {
    if (
        !selectedCourse ||
        !selectedClass
    ) {
        setClassTeacher(null);
        return;
    }
    try {
        const params = {
            courseId: selectedCourse,
            classId: selectedClass,
            sectionId:
                showSection
                    ? selectedSection || "null"
                    : "null"
        };
        const res = await axios.get(
            `${BASE_URL}/api/subjectClassCourse/getClassTeacher`,
            {
                params
            }
        );
        setClassTeacher(
            res.data
        );
    }
    catch (err) {
        console.error(
            "Error fetching class teacher",
            err
        );
        setClassTeacher(null);
    }
};



  useEffect(() => {
    if (selectedCourse) {
      fetchClassesByCourse(selectedCourse);
    } else {
      setClasses([]);
      setSelectedClass("");
    }
  }, [selectedCourse]);
  useEffect(() => {
    if (selectedCourse && selectedClass) {
      fetchAssignedSubjects();
    } else {
      setAssignedSubjects([]);
    }
  }, [selectedCourse, selectedClass]);
 
  const fetchClassesByCourse = async (courseId) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/classes?course=${courseId}`);
      setClasses(res.data);
      setSelectedClass("");
    } catch (err) {
      console.error("Error fetching classes", err);
    }
  };
  /* const fetchAssignedSubjects = async () => {
    try {
        debugger;
      const res = await axios.get(`${BASE_URL}/api/subjectClassCourse`);
      const filtered = res.data.filter(
        (item) =>
          item.CourseID === parseInt(selectedCourse) &&
          item.ClassID === parseInt(selectedClass)
      );
      setAssignedSubjects(filtered);
    } catch (err) {
      console.error("Error fetching assigned subjects", err);
    }
  }; */

const fetchAssignedSubjects = async () => {
    if (!selectedCourse || !selectedClass) {
        setAssignedSubjects([]);
        setSelectedSubjectIDs([]);
        return;
    }

    try {
        const params = {
            courseId: Number(selectedCourse),
            classId: Number(selectedClass)
        };

        if (showSection && selectedSection) {
            params.sectionId = Number(selectedSection);
        } else if (!showSection) {
            params.sectionId = "null";
        }

        const res = await axios.get(
            `${BASE_URL}/api/subjectClassCourse`,
            { params }
        );

        const data = res.data || [];

        setAssignedSubjects(data);

        setSelectedSubjectIDs(
            data.map(item => Number(item.SubjectID))
        );

    } catch (err) {
        console.error(
            "Error fetching assigned subjects:",
            err
        );

        console.error(
            "Response:",
            err.response?.data
        );

        setAssignedSubjects([]);
        setSelectedSubjectIDs([]);
    }
};

 /*  const handleCheckboxChange = (id) => {
    setSelectedSubjectIDs((prev) =>
      prev.includes(id) ? prev.filter((sid) => sid !== id) : [...prev, id]
    );
  }; */
  const handleAssignSubjects = async () => {
    if (!selectedCourse) {
            alert("Please select Course.");
            return;
        }
        if (!selectedClass) {
            alert("Please select Class.");
            return;
        }
        /*
         * If the selected class has sections,
         * section must be selected.
         */
        if (
            showSection &&
            !selectedSection
        ) {

            alert(
                "Please select Section."
            );
            return;
        }
        if (
            selectedSubjectIDs.length === 0
        ) {

            alert(
                "Please select at least one subject."
            );

            return;

        }
    try {
       setLoading(true);
      for (const subjectID of selectedSubjectIDs) {
         const existing = assignedSubjects.find(x =>
        Number(x.SubjectID) === Number(subjectID) &&
        Number(x.CourseID) === Number(selectedCourse) &&
        Number(x.ClassID) === Number(selectedClass) &&
        (
            (showSection
                ? Number(x.SectionID)
                : null)
            ===
            (showSection
                ? Number(selectedSection)
                : null)
        )
    );
 const payload = {
        StaffRegID:
                    selectedStaff
                        ? Number(selectedStaff)
                        : null,
        //AcademicYearID: Number(selectedAcademicYear),
        SubjectID: Number(subjectID),
        ClassID:  Number(selectedClass),
            SectionID:
showSection && Number(selectedSection) > 0
    ? Number(selectedSection)
    : null,
        CourseID: Number(selectedCourse),
        MakeClassTeacher: Boolean(makeClassTeacher)
    };
   if (!existing) {
    await axios.post(
        `${BASE_URL}/api/subjectClassCourse`,
        payload
    );
}
/* else if (existing.AssignmentID) {
    await axios.put(
        `${BASE_URL}/api/subjectClassCourse/${existing.AssignmentID}`,
        payload
    );
}
else {
    await axios.post(
        `${BASE_URL}/api/subjectClassCourse/assignStaff`,
        payload
    );
} */
      }
      /* ========================================================
           ASSIGN CLASS TEACHER
        ======================================================== */

        if (makeClassTeacher) {

            if (!selectedStaff) {

                alert(
                    "Please select Staff."
                );

                return;
            }


            const classTeacherPayload = {

                StaffRegID:
                    Number(selectedStaff),

                CourseID:
                    Number(selectedCourse),

                ClassID:
                    Number(selectedClass),

                SectionID:
                    showSection &&
                    Number(selectedSection) > 0

                        ? Number(selectedSection)

                        : null
            };


            await axios.post(
                `${BASE_URL}/api/subjectClassCourse/assignClassTeacher`,
                classTeacherPayload
            );


            /*
             * Reload class teacher
             */

            const teacherRes =
                await axios.get(
                    `${BASE_URL}/api/subjectClassCourse/getClassTeacher`,
                    {
                        params: {
                            courseId:
                                selectedCourse,

                            classId:
                                selectedClass,

                            sectionId:
                                showSection
                                    ? selectedSection
                                    : null
                        }
                    }
                );


            setClassTeacher(
                teacherRes.data
            );
        }

      alert("Subjects assigned successfully.");
      setSelectedSubjectIDs([]);
       setMakeClassTeacher(false);
      fetchAssignedSubjects();
    } catch (err) {
             console.error(
            "ASSIGN SUBJECT ERROR:",
            err
        );


        alert(
            err.response?.data?.message ||
            err.response?.data?.error ||
            "Error assigning subjects."
        );

    } finally {

        setLoading(false);
    }
  };


  /* const handleClassTeacherCheckbox = async (e) => {

    const checked = e.target.checked;


    if (!checked) {

        setMakeClassTeacher(false);

        return;
    }


    if (!selectedStaff) {

        alert(
            "Please select Staff first."
        );

        return;
    }


    if (!selectedCourse) {

        alert(
            "Please select Course."
        );

        return;
    }


    if (!selectedClass) {

        alert(
            "Please select Class."
        );

        return;
    }


    if (
        showSection &&
        !selectedSection
    ) {

        alert(
            "Please select Section."
        );

        return;
    }


    try {

        const res = await axios.get(
            `${BASE_URL}/api/subjectClassCourse/checkClassTeacher`,
            {
                params: {
                    courseId: selectedCourse,
                    classId: selectedClass,
                    sectionId:
                        showSection
                            ? selectedSection
                            : null,
                    staffId: selectedStaff
                }
            }
        );


        if (!res.data.canAssign) {

            setMakeClassTeacher(false);

            alert(
                res.data.message
            );

            return;
        }


        setMakeClassTeacher(true);


    } catch (err) {

        console.error(
            "CLASS TEACHER CHECK ERROR:",
            err
        );

        setMakeClassTeacher(false);

        alert(
            err.response?.data?.message ||
            "Unable to check Class Teacher."
        );
    }
}; */

const handleClassTeacherCheck = async (checked) => {

    if (!checked) {

        setMakeClassTeacher(false);

        return;
    }

    if (!selectedStaff) {

        alert(
            "Please select a staff member first."
        );

        return;
    }

    if (!selectedCourse || !selectedClass) {

        alert(
            "Please select Course and Class first."
        );

        return;
    }

    try {

        const res = await axios.get(
            `${BASE_URL}/api/subjectClassCourse/getClassTeacher`,
            {
                params: {
                    courseId: selectedCourse,
                    classId: selectedClass,
                    sectionId:
                        selectedSection || ""
                }
            }
        );

        const existingTeacher = res.data;

        /*
         * Someone else is already class teacher
         */
        if (
            existingTeacher &&
            Number(existingTeacher.StaffRegID) !==
                Number(selectedStaff)
        ) {

            alert(
                `Class Teacher is already assigned to ${existingTeacher.FullName}.`
            );

            setMakeClassTeacher(false);

            return;
        }

        setClassTeacher(existingTeacher);
        setMakeClassTeacher(true);

    }
    catch (err) {

        console.error(
            "Class teacher check error:",
            err
        );

        alert(
            err.response?.data?.message ||
            "Unable to check class teacher."
        );

        setMakeClassTeacher(false);
    }
};



const handleStaffChange = async (staffID) => {

    setSelectedStaff(staffID);

    setMakeClassTeacher(false);
    setClassTeacher(null);

    if (
        !staffID ||
        !selectedCourse ||
        !selectedClass
    ) {

        /*
         * If staff is cleared,
         * show all subjects for current
         * course/class/section again.
         */
        await loadAssignments(
            selectedClass,
            selectedSection || null,
            null
        );

        return;
    }

    try {

        /*
         * -----------------------------------------------
         * LOAD SUBJECTS ASSIGNED TO THIS STAFF
         * -----------------------------------------------
         */

        const subjectRes = await axios.get(
            `${BASE_URL}/api/subjectClassCourse`,
            {
                params: {
                    courseId: selectedCourse,
                    classId: selectedClass,
                    sectionId: selectedSection || "",
                    staffId: staffID
                }
            }
        );

        const subjects = subjectRes.data || [];

        setAssignedSubjects(subjects);

        /*
         * Select only subjects assigned
         * to this staff.
         */
        setSelectedSubjectIDs(
            subjects.map(item =>
                Number(item.SubjectID)
            )
        );


        /*
         * -----------------------------------------------
         * CHECK CLASS TEACHER
         * -----------------------------------------------
         */

        const teacherRes = await axios.get(
            `${BASE_URL}/api/subjectClassCourse/getClassTeacher`,
            {
                params: {
                    courseId: selectedCourse,
                    classId: selectedClass,
                    sectionId:
                        selectedSection || ""
                }
            }
        );

        const teacher = teacherRes.data || null;

        setClassTeacher(teacher);


        /*
         * If selected staff is already
         * the class teacher:
         *
         * CHECK CHECKBOX
         */
        if (
            teacher &&
            Number(teacher.StaffRegID) ===
                Number(staffID)
        ) {

            setMakeClassTeacher(true);

        } else {

            setMakeClassTeacher(false);

        }

    }
    catch (err) {

        console.error(
            "Staff change error:",
            err
        );

        setAssignedSubjects([]);
        setSelectedSubjectIDs([]);
        setClassTeacher(null);
        setMakeClassTeacher(false);
    }
};
const handleDeleteMapping = async (item) => {
   if (!window.confirm("Are you sure you want to remove this assignment?"))
        return;
       try {
        console.log(item);

     const res = await axios.delete(`${BASE_URL}/api/subjectClassCourse`, {
        data: {
             StaffRegID: item.StaffRegID,
            CourseID: item.CourseID,
            ClassID: item.ClassID,
            SectionID: item.SectionID,
            SubjectID: item.SubjectID
        }
    });
alert(res.data.message ||
            "Assignment deleted successfully.");   // Success message
    fetchAssignedSubjects();
     } 
     catch (err) {
        console.error(
            "DELETE ASSIGNMENT ERROR:",
            err
        );
    console.log(err);
    console.log(err.res?.data);
    alert(err.res?.data?.error || "Unable to delete.");
}
};

/* ============================================================
   DELETE CLASS TEACHER
============================================================ */

const handleDeleteClassTeacher = async () => {

    if (!classTeacher) {

        alert(
            "No Class Teacher is currently assigned."
        );

        return;

    }


    if (!selectedCourse || !selectedClass) {

        alert(
            "Please select Course and Class first."
        );

        return;

    }


    if (
        showSection &&
        !selectedSection
    ) {

        alert(
            "Please select Section first."
        );

        return;

    }


    const teacherName =
        classTeacher.FullName ||
        "this Class Teacher";


    const confirmed =
        window.confirm(
            `Are you sure you want to delete Class Teacher "${teacherName}"?`
        );


    if (!confirmed) {
        return;
    }


    try {

        setLoading(true);


        const payload = {

            CourseID:
                Number(selectedCourse),

            ClassID:
                Number(selectedClass),

            SectionID:
                showSection &&
                Number(selectedSection) > 0

                    ? Number(selectedSection)

                    : null

        };


        console.log(
            "Deleting Class Teacher:",
            payload
        );


        const res =
            await axios.delete(
                `${BASE_URL}/api/subjectClassCourse/deleteClassTeacher`,
                {
                    data: payload
                }
            );


        alert(
            res.data?.message ||
            "Class Teacher deleted successfully."
        );


        /* ========================================================
           CLEAR CLASS TEACHER UI
        ======================================================== */

        setClassTeacher(null);

        setMakeClassTeacher(false);

        setSelectedStaff("");


        /* ========================================================
           IMPORTANT:
           Reload current assignments
        ======================================================== */

        await loadAssignments(
            selectedClass,
            showSection
                ? selectedSection
                : null,
            null
        );


    } catch (err) {

        console.error(
            "DELETE CLASS TEACHER ERROR:",
            err
        );


        console.error(
            "Response:",
            err.response?.data
        );


        alert(

            err.response?.data?.message ||

            err.response?.data?.error ||

            "Unable to delete Class Teacher."

        );

    } finally {

        setLoading(false);

    }

};



/* ========================================================
       COURSE CHANGE
    ======================================================== */
const handleCourseChange = async (courseID) => {

    setSelectedCourse(courseID);

    setSelectedClass("");
    setSelectedSection("");
    setSelectedStaff("");

    setAssignedSubjects([]);
    setClassTeacher(null);
    setSelectedSubjectIDs([]);
    setMakeClassTeacher(false);

    if (!courseID) {
        return;
    }

    try {

        /*
         * Load classes for course
         */
        const classRes = await axios.get(
            `${BASE_URL}/api/classes`,
            {
                params: {
                    course: courseID
                }
            }
        );

        setClasses(classRes.data || []);


        /*
         * Load subjects for COURSE
         *
         * No class
         * No staff
         * Backend automatically uses
         * current academic year.
         */
        const subjectRes = await axios.get(
            `${BASE_URL}/api/subjectClassCourse`,
            {
                params: {
                    courseId: courseID
                }
            }
        );

        const subjects = subjectRes.data || [];

        setAssignedSubjects(subjects);

        /*
         * Check assigned subject checkboxes
         */
        setSelectedSubjectIDs(
            subjects.map(item =>
                Number(item.SubjectID)
            )
        );

    }
    catch (err) {

        console.error(
            "Course change error:",
            err
        );

        setAssignedSubjects([]);
        setSelectedSubjectIDs([]);
    }
};
/*     const handleCourseChange = async (courseID) => {
        setSelectedCourse(courseID);
        setSelectedAcademicYear("");
        setSelectedClass("");
        setSelectedSection("");
        setSelectedStaff("");
        setAcademicYears([]);
        setClasses([]);
        setSections([]);
        setShowSection(false);
        setAssignedSubjects([]);
        setClassTeacher(null);
         setMakeClassTeacher(false);
        if (!courseID) {
            return;
        }
        try {
            const [
                yearRes,
                classRes
            ] = await Promise.all([
                axios.get(
                    `${BASE_URL}/api/subjectClassCourse/getAcademicYears`,
                    {
                        params: {
                            courseId: courseID
                        }
                    }
                ),
                axios.get(
                    `${BASE_URL}/api/classes`,
                    {
                        params: {
                            course: courseID
                        }
                    }
                )

            ]);


            setAcademicYears(
                yearRes.data
            );

            

            setClasses(
                classRes.data
            );

        }
        catch (err) {

            console.error(
                "Course data error:",
                err
            );

        }

    }; */


/*     const handleCourseChange = async (courseID) => {

    setSelectedCourse(courseID);

    setSelectedClass("");
    setSelectedSection("");
    setSelectedStaff("");

    setAssignedSubjects([]);
    setClassTeacher(null);

    setShowSection(false);
    setMakeClassTeacher(false);


    if (!courseID) {
        return;
    }


    try {

       

        const classRes = await axios.get(
            `${BASE_URL}/api/classes`,
            {
                params: {
                    course: courseID
                }
            }
        );

        setClasses(classRes.data);


       

        const subjectRes = await axios.get(
            `${BASE_URL}/api/subjectClassCourse`,
            {
                params: {
                    courseId: courseID
                }
            }
        );

        setAssignedSubjects(
            subjectRes.data
        );

    } catch (err) {

        console.error(
            "COURSE CHANGE ERROR:",
            err
        );

        alert(
            err.response?.data?.message ||
            "Unable to load course data."
        );
    }
}; */

/* const handleClassChange = async (classID) => {
  setSelectedClass(classID);
  // Reset section
  setSelectedSection("");
  setSections([]);
  setSelectedSubjectIDs([]);
  setShowSection(false);
   setAssignedSubjects([]);
   setClassTeacher(null);
    setSelectedStaff("");
    setMakeClassTeacher(false);
  if (!classID) return;
  try {
    const res = await axios.get(
      `${BASE_URL}/api/sections/${classID}`
    );
    if (res.data.length > 0) {
      setSections(res.data);
      setShowSection(true);
    } else {
      setShowSection(false);
       
                await loadAssignments(
                    classID,
                    null
                );
    }
  } catch (err) {
    console.error(err);
    setShowSection(false);
  }
}; */



const handleClassChange = async (classID) => {

    setSelectedClass(classID);

    setSelectedSection("");
    setSelectedStaff("");
setSections([]);
    setShowSection(false);
    setAssignedSubjects([]);
    setSelectedSubjectIDs([]);

    setClassTeacher(null);
    setMakeClassTeacher(false);

    if (!classID || !selectedCourse) {
        return;
    }

    try {

        /*
         * Load sections
         */
      /*   const sectionRes = await axios.get(
      `${BASE_URL}/api/sections/${classID}`
    ); */
        const sectionRes = await axios.get(
            `${BASE_URL}/api/sections`,
            {
                params: {
                    classID: Number(classID)
                }
            }
        );

        const sectionData = sectionRes.data || [];
console.log("SECTIONS FOR CLASS", classID, sectionData);
        setSections(sectionData);

        setShowSection(sectionData.length > 0);


        /*
         * Load subjects for:
         *
         * Course + Class
         */
        const subjectRes = await axios.get(
            `${BASE_URL}/api/subjectClassCourse`,
            {
                params: {
                    courseId: Number(selectedCourse),
                    classId: Number(classID)
                }
            }
        );

        const subjects = subjectRes.data || [];

        setAssignedSubjects(subjects);

        /*
         * Select assigned subjects
         */
        setSelectedSubjectIDs(
            subjects.map(item =>
                Number(item.SubjectID)
            )
        );

        // =========================================================
        // LOAD CLASS TEACHER
        // =========================================================
        const teacherRes = await axios.get(
            `${BASE_URL}/api/subjectClassCourse/getClassTeacher`,
            {
                params: {
                    courseId: Number(selectedCourse),
                    classId: Number(classID),
                    sectionId: ""
                }
            }
        );

        const teacher = teacherRes.data || null;

        setClassTeacher(teacher);

    } catch (err) {
        console.error("CLASS CHANGE ERROR:", err);
        console.error("Response:", err.response?.data);

        setSections([]);
        setShowSection(false);

        setAssignedSubjects([]);
        setSelectedSubjectIDs([]);

        setClassTeacher(null);
        setMakeClassTeacher(false);
    }
};


    /* ========================================================
       SECTION CHANGE
    ======================================================== */

 /*    const handleSectionChange = async (sectionID) => {

        setSelectedSection(sectionID);
         setSelectedStaff("");

        setAssignedSubjects([]);
        setClassTeacher(null);
 setMakeClassTeacher(false);
        if (!selectedClass) {
            return;
        }


        await loadAssignments(
            selectedClass,
            sectionID || null
        );

    }; */



const handleSectionChange = async (sectionID) => {

    setSelectedSection(sectionID);
    setSelectedStaff("");

    setAssignedSubjects([]);
    setSelectedSubjectIDs([]);

    setClassTeacher(null);
    setMakeClassTeacher(false);

    if (!selectedCourse || !selectedClass) {
        return;
    }

    try {

        const subjectRes = await axios.get(
            `${BASE_URL}/api/subjectClassCourse`,
            {
                params: {
                    courseId: selectedCourse,
                    classId: selectedClass,
                    sectionId: sectionID || ""
                }
            }
        );

        const subjects = subjectRes.data || [];

        setAssignedSubjects(subjects);

        setSelectedSubjectIDs(
            subjects.map(item =>
                Number(item.SubjectID)
            )
        );


        /*
         * Load existing class teacher
         */
        const teacherRes = await axios.get(
            `${BASE_URL}/api/subjectClassCourse/getClassTeacher`,
            {
                params: {
                    courseId: selectedCourse,
                    classId: selectedClass,
                    sectionId: sectionID || ""
                }
            }
        );

        const teacher = teacherRes.data || null;

        setClassTeacher(teacher);

        /*
         * If a class teacher exists,
         * select that staff.
         */
        if (teacher) {

            setSelectedStaff(
                String(teacher.StaffRegID)
            );

            setMakeClassTeacher(true);

        }

    }
    catch (err) {

        console.error(
            "Section change error:",
            err
        );
    }
};


    /* ========================================================
       LOAD EXISTING ASSIGNMENTS
    ======================================================== */

    /* ========================================================
   LOAD EXISTING ASSIGNMENTS
======================================================== */

const loadAssignments = async (
    classID = selectedClass,
    sectionID = selectedSection || null,
    staffID = selectedStaff || null
) => {

    if (!selectedCourse) {

        setAssignedSubjects([]);
        setSelectedSubjectIDs([]);
        setClassTeacher(null);

        return;
    }

    try {

        // ====================================================
        // SUBJECT API PARAMETERS
        // ====================================================

        const subjectParams = {
            courseId: selectedCourse
        };

        if (classID) {
            subjectParams.classId = classID;
        }

        if (
            sectionID !== null &&
            sectionID !== undefined &&
            sectionID !== ""
        ) {
            subjectParams.sectionId = sectionID;
        }

        if (staffID) {
            subjectParams.staffId = staffID;
        }


        // ====================================================
        // LOAD SUBJECT ASSIGNMENTS
        // ====================================================

        const subjectRes = await axios.get(
            `${BASE_URL}/api/subjectClassCourse`,
            {
                params: subjectParams
            }
        );

        const subjects =
            subjectRes.data || [];


        setAssignedSubjects(subjects);


        // ====================================================
        // CHECKED SUBJECT IDS
        // ====================================================

        setSelectedSubjectIDs(
            subjects.map(
                item => Number(item.SubjectID)
            )
        );


        // ====================================================
        // LOAD CLASS TEACHER
        // ====================================================

        if (classID) {

            const teacherRes = await axios.get(
                `${BASE_URL}/api/subjectClassCourse/getClassTeacher`,
                {
                    params: {
                        courseId: selectedCourse,
                        classId: classID,
                        sectionId:
                            sectionID || ""
                    }
                }
            );

            const teacher =
                teacherRes.data || null;


            setClassTeacher(teacher);


            // =================================================
            // EXISTING CLASS TEACHER
            // =================================================

            if (teacher) {

                setSelectedStaff(
                    String(
                        teacher.StaffRegID
                    )
                );

                setMakeClassTeacher(true);

            }

        } else {

            setClassTeacher(null);
            setMakeClassTeacher(false);

        }

    }
    catch (err) {

        console.error(
            "Load assignments error:",
            err
        );

        console.error(
            "Response:",
            err.response?.data
        );

        setAssignedSubjects([]);
        setSelectedSubjectIDs([]);
        setClassTeacher(null);
    }
};
/* ========================================================
       ACADEMIC YEAR CHANGE
    ======================================================== */
    /* const handleAcademicYearChange = async (
        academicYearID
    ) => {
        setSelectedAcademicYear(
            academicYearID
        );
        setSelectedClass("");
        setSelectedSection("");
        setAssignedSubjects([]);
        setClassTeacher(null);
        setSelectedStaff("");
        setSections([]);
        setShowSection(false);
    }; */
    const handleSubjectCheckbox = (subjectID) => {

    setSelectedSubjectIDs(prev => {

        if (prev.includes(subjectID)) {

            return prev.filter(
                id => id !== subjectID
            );

        }

        return [
            ...prev,
            subjectID
        ];

    });
};
  return (
    <div className="container mt-4">
      <h3>Assign Subjects to Course and Class</h3>
      <div className="row mb-3">
        <div className="col-md-4">
          <label>Course</label>
          <select
            className="form-select"
            value={selectedCourse}
            onChange={(e) => setSelectedCourse(e.target.value)}
            required
          >
            <option value="">Select Course</option>
            {courses.map((course) => (
              <option key={course.CourseID} value={course.CourseID}>
                {course.CourseName}
              </option>
            ))}
          </select>
        </div>
{/* <FormControl fullWidth>
    <InputLabel>Academic Year</InputLabel>

    <Select
        value={
            selectedAcademicYear?.AcademicYearID || ""
        }
        label="Academic Year"
        disabled
    >
        {selectedAcademicYear && (
            <MenuItem
                value={selectedAcademicYear.AcademicYearID}
            >
                {selectedAcademicYear.AcademicYearName}
            </MenuItem>
        )}
    </Select>
</FormControl> */}

{/* <select
    className="form-select"
    value={selectedAcademicYear}
    onChange={(e) =>
        setSelectedAcademicYear(e.target.value)
    }
>
    <option value="">
        Select Academic Year
    </option>

    {academicYears.map((year) => (
        <option
            key={year.AcademicYearID}
            value={year.AcademicYearID}
        >
            {year.AcademicYearName}
        </option>
    ))}
</select> */}



        {/* <div className="col-md-4">
    <label>Staff</label>
    <select
        className="form-select"
        value={selectedStaff}
        onChange={(e)=>setSelectedStaff(e.target.value)}
    >
        <option value="">Select Staff</option>
        {
            staffs.map((staff)=>(
                <option
                    key={staff.Reg_Id}
                    value={staff.Reg_Id}
                >
                    {staff.FullName}
                </option>
            ))
        }
    </select>
</div> */}

<div className="col-md-4">
    <label className="form-label">
        Staff
    </label>
    <select
        className="form-select"
        value={selectedStaff}
        onChange={(e) => {
           handleStaffChange(e.target.value)
           /*  setMakeClassTeacher(false); */
        }}
    >
        <option value="">
            Select Staff
        </option>
        {staffs.map((staff) => (
            <option
                key={staff.Reg_Id}
                value={staff.Reg_Id}
            >
                {staff.FullName}
            </option>
        ))}
    </select>
    {selectedStaff && (

        <FormControlLabel
    control={
        <Checkbox
            checked={makeClassTeacher}
            onChange={handleClassTeacherCheck}
            disabled={
                !selectedStaff ||
                !selectedCourse ||
                !selectedClass ||
                (showSection && !selectedSection)
            }
        />
    }
    label="Make this staff the Class Teacher"
/>


    )}
    {/* ============================================================
    CLASS TEACHER
============================================================ */}

{selectedStaff && (

    <div className="mt-3">

        <div className="border rounded p-3 bg-light">

            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

                <div>

                    <div className="fw-bold mb-1">
                        Class Teacher
                    </div>


                    {classTeacher ? (

                        <div className="text-success">

                            <strong>
                                {classTeacher.FullName}
                            </strong>

                            <span className="ms-2">
                                ✓ Assigned
                            </span>

                        </div>

                    ) : (

                        <div className="text-muted">

                            No Class Teacher assigned.

                        </div>

                    )}

                </div>


                {/* =================================================
                    DELETE BUTTON
                ================================================= */}

                {classTeacher && (

                    <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        onClick={
                            handleDeleteClassTeacher
                        }
                        disabled={loading}
                    >

                        {loading
                            ? "Deleting..."
                            : "🗑 Delete Class Teacher"}

                    </button>

                )}

            </div>


            {/* =================================================
                ASSIGN CHECKBOX
            ================================================= */}

            {!classTeacher && (

                <div className="mt-3">

                    <FormControlLabel

                        control={

                            <Checkbox
                                checked={
                                    makeClassTeacher
                                }
                                onChange={(e) =>
                                    handleClassTeacherCheck(
                                        e.target.checked
                                    )
                                }
                            />

                        }

                        label="Assign Class Teacher"

                    />

                </div>

            )}

        </div>

    </div>

)}
</div>
{selectedClass && (
    <div className="alert alert-secondary mt-3">
        <strong>
            Class Teacher:
        </strong>{" "}
        {classTeacher?.FullName
            ? classTeacher.FullName
            : "Not Assigned"}
    </div>
)}
        <div className="col-md-4">
          <label>Class</label>
          <select
            className="form-select"
            value={selectedClass}
            onChange={(e)=>handleClassChange(e.target.value)}
            disabled={!selectedCourse}
            required
          >
            <option value="">Select Class</option>
            {classes.map((cls) => (
              <option key={cls.id} value={cls.id}>
                {cls.name}
              </option>
            ))}
          </select>
        </div>
        {showSection && (
    <div className="col-md-4">
        <label className="form-label">Section</label>

        <select
            className="form-select"
            value={selectedSection}
            onChange={(e) =>
                handleSectionChange(e.target.value)
            }
            disabled={!selectedClass}
        >
            <option value="">
                Select Section
            </option>

            {sections.map(section => (
                <option
                    key={section.SectionID}
                    value={section.SectionID}
                >
                    {section.SectionName}
                </option>
            ))}
        </select>
    </div>
)}
      </div>
      <h5>Select Subjects</h5>
      <div className="row">
        {subjects.map((subj) => (
          <div className="col-md-3" key={subj.SubjectID}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value={subj.SubjectID}
                checked={selectedSubjectIDs.includes(subj.SubjectID)}
                onChange={() =>  handleSubjectCheckbox(subj.SubjectID)}
              />
              <label className="form-check-label">{subj.SubjectName}</label>
            </div>
          </div>
        ))}
      </div>
      <button
        className="btn btn-success mt-3"
        onClick={handleAssignSubjects}
        /* disabled={!selectedCourse || !selectedClass || (showSection && !selectedSection) ||  !selectedStaff || selectedSubjectIDs.length === 0} */
        disabled={!selectedCourse || !selectedClass || selectedSubjectIDs.length === 0}
      >
        Assign Selected Subjects
      </button>
      <hr />
      <h5>Assigned Subjects</h5>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Staff</th>
            <th>Subject</th>
            <th>Course</th>
            <th>Class</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {assignedSubjects.map((item) => (
            <tr key={item.ID}>
              <td>{item.FullName || "Not Assigned"}</td>
              <td>{item.SubjectName}</td>
              <td>{item.CourseName}</td>
              <td>{item.ClassName}</td>
              <td>
                <button
                  className="btn btn-danger btn-sm"
                 /*  onClick={() => handleDeleteMapping(item.ID)} */
                  onClick={() => handleDeleteMapping(item)}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default AssignSubjects;
